import React from 'react'
import { Box, Text, VStack } from '@chakra-ui/react'
import { RecordingPlayer } from './RecordingPlayer'
import { useSelectedResidentContact } from '../contact-center.hooks'
import { useCallRecordings } from './call-recording.hook'
import moment from 'moment'
//import { useSelectedResidentContact } from '..'

type CallRecordingProps = {}

export const CallRecording: React.FC<CallRecordingProps> = () => {
  const { selected } = useSelectedResidentContact()

  const recordings = useCallRecordings(selected?.phoneNumber)

  return (
    <Box
      borderBottom="1px solid #CBD5E0"
      p={3}
      minH="300px"
      maxH="350px"
      overflowY="auto"
      sx={{
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#4299e1',
          borderRadius: '3px',
          border: '2px solid #f1f1f1',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#4299e1',
        },
        scrollbarWidth: 'thin',
      }}
    >
      <Text color="gray-600" fontSize="14px" fontWeight="600" lineHeight="20px">
        Call Recordings
      </Text>
      <Box mt="25px">
        {!!recordings?.length ? (
          <VStack spacing={4}>
            {recordings?.map(recording => {
              return (
                <>
                  <Text fontSize="12px" fontWeight="400" color="gray.700">
                    {moment.utc(recording.callTime).local().format('MMM D, h:mm A')}
                  </Text>
                  <RecordingPlayer src={recording.recordingUrl} />
                </>
              )
            })}
          </VStack>
        ) : (
          <Box mt="30%">
            <Text color="#718096" fontWeight="500" fontStyle="italic" fontSize="20px" textAlign="center">
              No recording
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}
